import React from "react";

import { Button, Spinner } from "@amphore-dev/amphore-lib";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

import { useSubscription } from "@/hooks/useSubscription";

import { SubscriptionCurrentCard } from "./SubscriptionSection";

/**
 * The "my subscription" card on the profile: same block as
 * /subscription, with a button to that page in place of the portal -
 * changing plan is done there, next to the plans on offer.
 */
export const SubscriptionSummary: React.FC<{ className?: string }> = ({
	className,
}) => {
	const { state, isLoading, error } = useSubscription();
	const navigate = useNavigate();

	if (isLoading) return <Spinner className="mx-auto my-6" />;
	if (error || !state) return null;

	return (
		<SubscriptionCurrentCard
			state={state}
			className={className}
			actions={
				<Button
					variant="outline"
					size="sm"
					picto="arrowUpRight"
					onClick={() => navigate("/subscription")}
					data-testid="subscription-summary-cta"
				>
					{t("subscription.current.changePlan")}
				</Button>
			}
		/>
	);
};
